import React from 'react';
import Downloads from '../Downloads/Downloads';
import Requests from '../Requests/Requests';
import Reviews from '../Reviews/Reviews';
import Shelves from '../Shelves/Shelves';
import ViewType from '../UI/ViewType';
import LaneContainer from '../UI/LaneContainer';
import './yourBooks.less';
import PropTypes from 'prop-types';
import { Translate } from '@above-the-treeline/localization';

YourBooks.propTypes = {
	viewType: PropTypes.string,
};

export default function YourBooks({ viewType }) {
	return (
		<div
			className={`your-books ${
				viewType === ViewType.Drawer
					? 'drawer-frame'
					: 'main-route-frame'
			}`}>
			<LaneContainer
				majorHeader={<Translate id={'your_books'} />}
				description={<Translate id={'your_books_help'} />}
			/>
			<Shelves />
			<Requests />
			<Downloads />
			<Reviews />
		</div>
	);
}
